// Definição única do menu lateral. Fica fora do componente para a tela de
// Permissões mostrar cada permissão com o mesmo nome que aparece no menu.
export interface SidebarItem {
  label: string;
  route?: string;
  exact?: boolean;
  expanded?: boolean;
  permissao?: string;
  icon?: string;
  children?: SidebarItem[];
}

export const SIDEBAR_MENU: SidebarItem[] = [
  {
    label: 'Dashboard',
    route: '/dashboard',
    exact: true,
    permissao: 'Dashboard',
    icon: 'dashboard'
  },
  {
    label: 'Dashboard Técnico',
    route: '/dashboard-tec',
    exact: true,
    permissao: 'DashboardTec',
    icon: 'monitoring'
  },
  {
    // Perto do topo de propósito: é onde o analista olha quando o sininho
    // acende, e alerta que fica escondido no fim do menu não é alerta.
    label: 'Alertas',
    route: '/alertas',
    exact: true,
    permissao: 'Operacoes',
    icon: 'notifications'
  },
  {
    //Aba Cadastros
    label: 'Cadastros',
    expanded: false,
    icon: 'folder_open',
    children: [
      {
        // Junta os antigos Investidor e Incorporador (papéis da empresa).
        label: 'Empresa',
        route: '/empresa',
        exact: true,
        permissao: 'Investidores',
        icon: 'business'
      },
      {
        label: 'Empreendimentos',
        route: '/empreendimentos',
        exact: false,
        permissao: 'Empreendimentos',
        icon: 'home_work'
      },
      {
        label: 'Contas',
        route: '/cadastro-contas',
        exact: false,
        permissao: 'Empreendimentos',
        icon: 'account_balance_wallet'
      },
      {
        label: 'Operações',
        route: '/cadastro-operacoes',
        exact: false,
        permissao: 'Empreendimentos',
        icon: 'request_quote'
      },
      
      

    ]
  },
  {
    //Aba Gerenciar Acessos
    label: 'Gerenciar Acessos',
    expanded: false,
    permissao: 'GerenciarAcesso',
    icon: 'admin_panel_settings',
    children: [
      {
        label: 'Perfil',
        route: '/perfil',
        exact: false,
        icon: 'badge'
      },
      {
        label: 'Permissões',
        route: '/permissoes',
        exact: false,
        icon: 'lock'
      },
      {
        label: 'Sessão Empreend.',
        route: '/sessoes-operacao',
        exact: false,
        icon: 'sessaoEmpreendimento'
      }
    ]
  },
  {
    label: 'Credenciais de Operador',
    route: '/credenciais-operador',
    exact: true,
    permissao: 'CredenciaisOperador',
    icon: 'lock'
  },
  {
    label: 'Conexões Sienge',
    route: '/integracoes-sienge',
    exact: true,
    permissao: 'IntegracaoSienge',
    icon: 'link'
  },
  {

    //Aba Monitoramento (antiga Operações). O grupo Monitoramento que existia
    // (Empreendimento/Carteira) apontava para /carteira, rota que não existe,
    // e foi absorvido aqui.
    label: 'Monitoramento',
    expanded: false,
    icon: 'payments',
    children: [
      {
        label: 'Conciliação',
        route: '/operacoes/empreendimento',
        exact: false,
        permissao: 'Operacoes',
        icon: 'home_work'
      },
      {
        label: 'Espelho de Vendas',
        route: '/operacoes/espelho-vendas',
        exact: false,
        permissao: 'EspelhoVendas',
        icon: 'apartment'
      },
      // Sem `route`: aparecem no menu mas ainda não navegam para lugar
      // nenhum - as telas não existem. O template renderiza item sem rota
      // como texto, não como link (ver sidebar.html), então não há href
      // morto nem rota inventada esperando implementação.
      {
        label: 'Bdados',
        permissao: 'Operacoes',
        icon: 'folder_open'
      },
      {
        label: 'Carteira',
        permissao: 'Operacoes',
        icon: 'account_balance_wallet'
      },
      {
        label: 'Fluxo de Caixa',
        permissao: 'Operacoes',
        icon: 'savings'
      },
      {
        label: 'Relatório',
        permissao: 'Operacoes',
        icon: 'assessment'
      }
    ]
  },
  {
    label: 'Relatórios',
    route: '/relatorios',
    exact: true,
    permissao: 'Relatorios',
    icon: 'assessment'
  },
  {
    label: 'Convert',
    expanded: false,
    icon: 'find_in_page',
    children: [
      {
        label: 'Empreendimento',
        route: '/extrator/empreendimento',
        exact: false,
        permissao: 'Extrator',
        icon: 'home_work'
      }
    ]
  },
  {
    // Mapeamento: leiautes que ainda não têm regra de conversão no sistema.
    label: 'Mapeamento',
    expanded: false,
    icon: 'description',
    children: [
      {
        label: 'Novas Conversões',
        route: '/mapeamento/novas-conversoes',
        exact: true,
        // Tela própria (antes usava a do Convert e aparecia para todos com Convert).
        permissao: 'NovasConversoes',
        icon: 'upload_file'
      },
      {
        // Equipe de inovação: valida as regras criadas pela IA em Novas Conversões.
        label: 'Validação de Regras de Conversão',
        route: '/mapeamento/validacao-regras',
        exact: true,
        permissao: 'ValidacaoParsers',
        icon: 'fact_check'
      }
    ]
  },
  // {
  //   label: 'Gerenciar Vínculos',
  //   route: '/vinculos',
  //   exact: true,
  //   permissao: 'GerenciamentoVinculos',
  //   icon: 'link'
  // },
  {
    label: 'Auditor de Contrato',
    route: '/auditor-contrato',
    exact: true,
    permissao: 'AuditorContrato',
    icon: 'fact_check'
  },
  {
    label: 'Auditor Financeiro',
    route: '/auditor-financeiro',
    exact: true,
    permissao: 'AuditorFinanceiro',
    icon: 'account_balance'
  },
  {
    label: 'Engenharia',
    expanded: false,
    icon: 'apartment',
    children: [
      {
        label: 'Auditor Operações Financeiras',
        route: '/engenharia/auditor-fiscal',
        exact: true,
        permissao: 'AuditorFiscal',
        icon: 'fact_check'
      },
      {
        label: 'Contas Pagas',
        route: '/engenharia/contas-pagas',
        exact: true,
        permissao: 'ContasPagas',
        icon: 'payments'
      },
      {
        label: 'Conciliador de Notas',
        route: '/engenharia/conciliador-notas',
        exact: true,
        permissao: 'ConciliadorNotas',
        icon: 'receipt_long'
      }
    ]
  },
  {
    label: 'Monitor Obras',
    expanded: false,
    icon: 'home_work',
    children: [
      {
        label: 'Upload de Arquivos',
        route: '/monitor-obras/upload-arquivos',
        exact: true,
        permissao: 'MonitorObrasUpload',
        icon: 'description'
      },
      {
        label: 'Consulta',
        route: '/monitor-obras/consulta',
        exact: true,
        permissao: 'MonitorObrasConsulta',
        icon: 'visibility'
      }
    ]
  },
  //IMPORTAÇÃO DO CORE
  {
    label: 'Importação',
    expanded: false,
    icon: 'upload',
    children: [
      {
        label: 'Importar BRM',
        route: '/importacao/importar-brm',
        exact: true,
        permissao: 'ImportacaoBRM',
        icon: 'upload_file'
      },
      {
        label: 'Importar Operação',
        route: '/importacao/importar-operacao',
        exact: true,
        permissao: 'ImportacaoOperacao',
        icon: 'request_quote'
      }
    ]
  },
  //VISTOMOB (vistoria/medição física de obra pelo app mobile)
  {
    label: 'VistoMob',
    expanded: false,
    icon: 'photo_camera',
    children: [
      {
        label: 'Cenários PMC',
        route: '/vistomob/cenarios',
        exact: true,
        permissao: 'VistoMob',
        icon: 'upload_file'
      },
      {
        // exact: false para continuar marcado no detalhe (/vistomob/medicoes/:id).
        label: 'Medições',
        route: '/vistomob/medicoes',
        exact: false,
        permissao: 'VistoMob',
        icon: 'fact_check'
      },
      {
        label: 'Vistoriadores',
        route: '/vistomob/vistoriadores',
        exact: true,
        permissao: 'VistoMob',
        icon: 'badge'
      }
    ]
  },
  //API EXTERNA (consumo dos dados do BRM por terceiros)
  {
    label: 'API Externa',
    expanded: false,
    icon: 'link',
    children: [
      {
        label: 'Usuários externos',
        route: '/api-externa/usuarios',
        exact: true,
        permissao: 'UsuariosExternos',
        icon: 'badge'
      },
      {
        label: 'Vincular acessos',
        route: '/api-externa/vinculos',
        exact: true,
        permissao: 'UsuariosExternos',
        icon: 'admin_panel_settings'
      },
      {
        label: 'Consumo da API',
        route: '/api-externa/consumo',
        exact: true,
        permissao: 'ConsumoApiExterna',
        icon: 'assessment'
      },
      {
        label: 'Documentação',
        route: '/api-externa/documentacao',
        exact: true,
        permissao: 'UsuariosExternos',
        icon: 'description'
      }
    ]
  },
  //CONFIGURAÇÕES
  {
    label: 'Configurações',
    expanded: false,
    icon: 'settings',
    children: [
       {
          label: 'Logs',
          route: '/logs',
          exact: true,
          permissao: 'Log',
          icon: 'history'
      },
      {
        label: 'Feriados',
        route: '/feriados',
        exact: true ,
        permissao: 'Feriados',
        icon: 'calendar_month'
      },
      {
        label: 'Escopos',
        route: '/escopos',
        exact: true,
        permissao: 'Empreendimentos',
        icon: 'checklist'
      },
      {
        label: 'Classif. Contas Pagas',
        route: '/classificacoes-contas-pagas',
        exact: true ,
        permissao: 'ClassificacoesContasPagas',
        icon: 'category'
      },
      {
        label: 'Gerenciar Vínculos',
        route: '/vinculos',
        exact: true,
        permissao: 'GerenciamentoVinculos',
        icon: 'link'
      },
      {
        label: 'Arq. Não Mapeados',
        route: '/extratos-bancarios-nao-identificados',
        exact: true,
        permissao: 'ArquivosNaoMapeados',
        icon: 'description'
      },
    ]
  }
];

// nomeTela (chave da permissão, em minúsculas) -> nome(s) no menu, ex.:
// 'operacoes' -> 'Alertas; Monitoramento: Conciliação, Bdados, Carteira'.
// Permissão sem item no menu não entra no mapa (a tela mostra o nome cru).
export function nomesMenuPorPermissao(menu: SidebarItem[] = SIDEBAR_MENU): Map<string, string> {
  const porPermissao = new Map<string, Map<string, string[]>>();

  const registrar = (permissao: string, grupo: string, label: string | null) => {
    const chave = permissao.toLowerCase();
    const grupos = porPermissao.get(chave) ?? new Map<string, string[]>();
    const labels = grupos.get(grupo) ?? [];
    if (label && !labels.includes(label)) labels.push(label);
    grupos.set(grupo, labels);
    porPermissao.set(chave, grupos);
  };

  for (const item of menu) {
    if (item.permissao) {
      registrar(item.permissao, item.children ? item.label : '', item.children ? null : item.label);
    }
    for (const filho of item.children ?? []) {
      if (filho.permissao) registrar(filho.permissao, item.label, filho.label);
    }
  }

  const resultado = new Map<string, string>();
  porPermissao.forEach((grupos, chave) => {
    const partes: string[] = [];
    grupos.forEach((labels, grupo) => {
      if (!grupo) partes.push(...labels);
      else partes.push(labels.length ? `${grupo}: ${labels.join(', ')}` : grupo);
    });
    resultado.set(chave, partes.join('; '));
  });
  return resultado;
}
